export default __webpack_public_path__ + "static/media/96_mobile.3c16f283.jpg";